import { checkoutReviewAndSubmitActionButtonsStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitActionButtons";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

checkoutReviewAndSubmitActionButtonsStyles.placeOrderButton = {
    css: css`
        flex-shrink: 0;
        margin-left: 10px;
        &.buttonTransition {
            background: linear-gradient(to left, #ea636b 50%, #ef3742 50%);
            background-size: 200% 100%;
            background-position: left bottom;
            animation: gradient-animation 9s ease-in-out infinite;
            @keyframes gradient-animation {
                0% {
                    background-position: right bottom;
                }
                100% {
                    background-position: left top;
                }
            }
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: 50%;
                    `,
                ],
                "max",
            )}
    `,
};
